import { render, staticRenderFns } from "./t-visite-medicale.html?vue&type=template&id=5643e61c&scoped=true&external"
import script from "./t-visite-medicale.js?vue&type=script&lang=js&external"
export * from "./t-visite-medicale.js?vue&type=script&lang=js&external"
import style0 from "./t-visite-medicale.scss?vue&type=style&index=0&id=5643e61c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5643e61c",
  null
  
)

export default component.exports